import { render } from "./waiterSalesModel.vue?vue&type=template&id=8167e31e"
import script from "./waiterSalesModel.vue?vue&type=script&lang=js"
export * from "./waiterSalesModel.vue?vue&type=script&lang=js"

import "./waiterSalesModel.vue?vue&type=style&index=0&id=8167e31e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__